import React from 'react'
import IconsAuraExp18 from './Images/IconsAuraExp18.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCircleChevronRight} from '@fortawesome/free-solid-svg-icons';



function ExpCard18() {
  return (
    

    <div className='ExpPgCard  '>
          
        <p className='ExpPgHExpName'> Backwaters of Kerala </p>

        <p className='ExpPgHCat'> Nature </p>
        <p className='ExpPgHCode'> AURAMUSE118 </p>

        

        <div className='IconsAuraExpDiv'>  <img className='IconsAuraExp' src={IconsAuraExp18} /> </div>

        <FontAwesomeIcon className='FaIconCirc' icon={faCircleChevronRight} size="xl" style={{color: " ", }} />
        

    </div>




  )
}

export default ExpCard18